package org.example.zone360.pages.coachDetails.sessionAllDetails

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Circle
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.style.KobwebComposeStyleSheet.attr
import com.varabyte.kobweb.compose.ui.graphics.Color
import org.example.zone360.models.ClubAverages
import org.example.zone360.models.CoachTalkRatio
import org.example.zone360.models.CognitiveTraining
import org.example.zone360.models.CognitiveTrainingSubScores
import org.example.zone360.models.CompetitiveEnvironment
import org.example.zone360.models.CompetitiveEnvironmentSubScores
import org.example.zone360.models.DevelopmentOrientation
import org.example.zone360.models.GameRealism
import org.example.zone360.models.GameRealismSubScores
import org.example.zone360.models.MatchAnalysis
import org.example.zone360.models.MatchAnalysisSubScores
import org.example.zone360.models.MethodologyConsistency
import org.example.zone360.models.SessionIntensity
import org.example.zone360.models.SessionWidgetMetrics
import org.example.zone360.models.TacticalComplexity
import org.example.zone360.models.TopicDiversity
import org.example.zone360.models.TopicsCovered
import org.example.zone360.models.TrainingPriority
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


fun SessionWidgetMetrics.toClubAverages(): ClubAverages {
    return ClubAverages(
        coachTalkRatio = CoachTalkRatio(
            score = coachTalkRatio.score
        ),

        cognitiveTraining = CognitiveTraining(
            score = cognitiveTraining.score,
            subScores = CognitiveTrainingSubScores(
                decisionMaking = cognitiveTraining.subScores.decisionMaking,
                perception = cognitiveTraining.subScores.perception,
                problemSolving = cognitiveTraining.subScores.problemSolving,
                scanning = cognitiveTraining.subScores.scanning,
                tacticalAwareness = cognitiveTraining.subScores.tacticalAwareness
            )
        ),

        competitiveEnvironment = CompetitiveEnvironment(
            score = competitiveEnvironment.score,
            subScores = CompetitiveEnvironmentSubScores(
                accountability = competitiveEnvironment.subScores.accountability,
                competition = competitiveEnvironment.subScores.competition,
                scoringSystems = competitiveEnvironment.subScores.scoringSystems,
                timePressure = competitiveEnvironment.subScores.timePressure,
                winningConditions = competitiveEnvironment.subScores.winningConditions
            )
        ),

        developmentOrientation = DevelopmentOrientation(
            score = developmentOrientation.score
        ),

        gameRealism = GameRealism(
            score = gameRealism.score,
            subScores = GameRealismSubScores(
                decisionMaking = gameRealism.subScores.decisionMaking,
                directionalPlay = gameRealism.subScores.directionalPlay,
                matchPressure = gameRealism.subScores.matchPressure,
                opposition = gameRealism.subScores.opposition,
                transitions = gameRealism.subScores.transitions
            )
        ),

        matchAnalysis = matchAnalysis?.let {
            MatchAnalysis(
                rootCauses = it.rootCauses,
                score = it.score,
                strengths = it.strengths,
                weaknesses = it.weaknesses,
                subScores = MatchAnalysisSubScores(
                    inPossession = it.subScores.inPossession,
                    outOfPossession = it.subScores.outOfPossession,
                    transitions = it.subScores.transitions
                ),
                trainingPriorities = it.trainingPriorities.map { priority ->
                    TrainingPriority(
                        area = priority.area,
                        percentage = priority.percentage
                    )
                }
            )
        } ?: MatchAnalysis(),

        methodologyConsistency = MethodologyConsistency(
            consistentPrinciples = methodologyConsistency.consistentPrinciples ?: emptyList(),
            score = methodologyConsistency.score
        ),

        sessionIntensity = SessionIntensity(
            score = sessionIntensity.score
        ),

        tacticalComplexity = TacticalComplexity(
            score = tacticalComplexity.score,
            topConcepts = tacticalComplexity.topConcepts
        ),

        topicDiversity = TopicDiversity(
            score = topicDiversity.score,
            topicsCovered = topicDiversity.topicsCovered.map {
                TopicsCovered(
                    topic = it.topic,
                    percentage = it.percentage
                )
            }
        )
    )
}
